import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import NANCheck from '../../../../components/react-isNAN';

const QuantityDisplay = ({quantity, className}) => {
  return (
    <NANCheck value={quantity}>
      <span className={cs('QuantityDisplay', className)}>{quantity}</span>
    </NANCheck>
  );
};

QuantityDisplay.propTypes = {
  quantity: PropTypes.number,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
};

export default QuantityDisplay;
